import React, { useState } from "react";
import { Alert } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import useFlash from "go-alert/AlertMessage";
import handleError from "go-app/services/errors";
import { organizationApi } from "../../../../../../../../services/Api/Organization/organizationApi";
import { VerifyTermApi } from "../../../../../../../../services/Api/Organization/organizationTypes";
import AddonTermsModal from "../FormNew/AddonTermsModal";
import { getParsedTermsNameToSnakeCase } from "../FormNew/services";

interface Props {
	terms: VerifyTermApi[];
	setTerms: React.Dispatch<React.SetStateAction<VerifyTermApi[]>>;
}

const SubscriptionTermsAlert = ({ terms, setTerms }: Props) => {
	const { t } = useTranslation();
	const [termsToAccept, setTermsToAccept] = useState<VerifyTermApi | undefined>();
	const { addFlash } = useFlash();

	const handleAccept = async () => {
		if (termsToAccept?.terms_name) {
			try {
				await organizationApi.acceptTerms(termsToAccept.terms_name);
				const newTerms = [...terms];
				const indexOfTerm = newTerms.findIndex(({ terms_name }) => terms_name === termsToAccept.terms_name);
				if (indexOfTerm > -1) {
					newTerms.splice(indexOfTerm, 1);
					setTerms(newTerms);
				}
			} catch (err) {
				handleError.alert(err, addFlash);
			}
		}
	};

	return (
		<Alert variant="danger">
			<span className="me-1">{t("modules.subscription.field.subscriptions_blocked_because_of_terms.title")}</span>
			{terms.map((term) => (
				<p
					key={term.terms_name}
					className="text-primary mb-0"
					style={{ cursor: "pointer" }}
					onClick={() => setTermsToAccept(term)}
				>
					{t(`enums.subscriptions.addon.terms.${getParsedTermsNameToSnakeCase(term.terms_name)}`)}
				</p>
			))}
			{termsToAccept && (
				<AddonTermsModal
					show={!!termsToAccept}
					onHide={() => setTermsToAccept(undefined)}
					terms={{
						name: termsToAccept.terms_name,
						url: termsToAccept.terms_url,
					}}
					handleAccept={handleAccept}
					submitButtonTitle={t("lib:common.action.save")}
				/>
			)}
		</Alert>
	);
};

export default SubscriptionTermsAlert;
